import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Select, Input, Table, notification, Dropdown } from "antd";
import moment from "moment";

import ActionButtons from "../../ActionButtons/ActionButtons";
import { NavigationPath, RoleOptionsValues } from "../../../helpers/constants";
import {
  CaretDownOutlined,
  FilePdfOutlined,
  MailOutlined,
} from "@ant-design/icons";
import ExportIcon from "../../../images/Export.svg";
import OfferDetailsModal from "../OfferDetailsModal";
import SendEmailModal from "../SendEmailModal";
import styles from "../Ponude.module.scss";
import { formatNumber } from "../../../helpers/formater";
const { Search } = Input;

const PonudeRestRoles = ({ state, actions }) => {
  const { loggedUser, suppliers, offers, years } = state;

  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, msg) => {
    api[type]({
      message: msg,
    });
  };
  const [searchYear, setSearchYear] = useState(null);
  const [searchClient, setSearchClient] = useState("");
  const [searchDobavljac, setSearchDobavljac] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);
  const [posaljiPonudu, setPosaljiPonudu] = useState(false);

  const [currentOffer, setCurrentOffer] = useState(null);

  useEffect(() => {
    if (loggedUser?.role === RoleOptionsValues.LEASING_KORISNIK) {
      actions.getSuppliers();
      actions.getOffers();
    }
    if (
      loggedUser?.role === RoleOptionsValues.DOBAVLJAC_ADMIN ||
      loggedUser?.role === RoleOptionsValues.DOBAVLJAC_KORISNIK
    ) {
      actions.getOffers(loggedUser?.supplierId);
    }

    actions.getYearsForOffers();
  }, [loggedUser]);

  useEffect(() => {
    setTableData(
      offers.map((offer) => ({
        key: offer.id,
        actions: renderActions(offer),
        broj: offer.offerNumber,
        imeprezime: offer.createdBy,
        datum: moment(offer.createdAt).format("YYYY-MM-DD"),
        kupac: offer.companyName,
        predmet: offer.assetType,
        bruto: formatNumber(offer.grossValue),
        iznos: formatNumber(offer.netValue),
        rata: formatNumber(offer.installment),
        trajanje: offer.duration,
        kamata: formatNumber(offer.interestRate),
        valuta: offer.currency,
        status: renderStatus(offer),
      }))
    );

    if (RoleOptionsValues) {
    }
  }, [offers]);

  const exportIconItems = [
    {
      label: "Detalji",
      key: "detalji",
    },
    {
      label: "PDF",
      key: "pdf",
      icon: <FilePdfOutlined />,
    },
  ];

  const statusItems = [
    {
      label: "Zaprimljen",
      key: "Zaprimljen",
    },
    {
      label: "Nerealiziran",
      key: "Nerealiziran",
    },
    {
      label: "U postupku",
      key: "U postupku",
    },
    {
      label: "Odobren",
      key: "Odobren",
    },
  ];

  const onClickActions = ({ key }, offer) => {
    if (key === "detalji") {
      setDetailsModal(true);
    } else {
      actions.generatePdf(offer.offerNumber);
    }
  };

  const onClickStatus = (e, offer) => {
    if (offer.status === e.key) {
      return;
    }
    actions.updateOfferStatusById(e.key, offer.id);
  };

  const renderActions = (offer) => (
    <div className="flex gap-2 ">
      <Dropdown
        trigger={["click"]}
        menu={{
          items: exportIconItems,
          onClick: (e) => onClickActions(e, offer),
        }}
      >
        <img
          className="h-[14px] cursor-pointer"
          src={ExportIcon}
          onClick={(e) => {
            e.preventDefault();
            setCurrentOffer(offer);
          }}
        />
      </Dropdown>

      <MailOutlined
        className="cursor-pointer"
        onClick={() => {
          setPosaljiPonudu(true);
          setCurrentOffer(offer);
        }}
      />
    </div>
  );

  const renderStatus = (offer) =>
    loggedUser?.role === RoleOptionsValues.LEASING_KORISNIK ? (
      <div className="flex gap-2 ">
        <Dropdown
          trigger={["click"]}
          menu={{
            items: statusItems,
            onClick: (e) => onClickStatus(e, offer),
          }}
        >
          <div
            className="w-full flex justify-between cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <div className="ml-1">{offer.status}</div>
            <CaretDownOutlined />
          </div>
        </Dropdown>
      </div>
    ) : (
      <>{offer.status}</>
    );

  const supplierSelectOptions = suppliers?.map((supplier) => ({
    value: supplier.key,
    label: supplier.kompanija,
  }));

  const yearsSelectOptions = years?.map((year) => ({
    value: year.year,
    label: year.year,
  }));

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      width: 50,
    },
    {
      title: "Broj",
      dataIndex: "broj",
      width: 60,
    },
    {
      title: "Ime i prezime",
      dataIndex: "imeprezime",
      render: (text) => <a className="text-light-blue">{text}</a>,
    },
    {
      title: "Datum",
      dataIndex: "datum",
      width: 100,
    },
    {
      title: "Naziv kupca",
      dataIndex: "kupac",
      filteredValue: [searchClient],
      onFilter: (value, record) => {
        return record.kupac.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Predmet",
      dataIndex: "predmet",
    },
    {
      title: "Vrijednost bruto",
      dataIndex: "bruto",
      width: 100,
    },
    {
      title: "Iznos Finansiranja",
      dataIndex: "iznos",
      width: 100,
    },
    {
      title: "Rata",
      dataIndex: "rata",
    },
    {
      title: "Trajanje godina",
      dataIndex: "trajanje",
      width: 60,
    },
    {
      title: "Kta",
      dataIndex: "kamata",
    },
    {
      title: "Valuta",
      dataIndex: "valuta",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 110,
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedUser(selectedRows);
    },
  };

  const navigateToWebCalculator = () => {
    navigate(NavigationPath.WEB_CALCULATOR_ROUTE);
  };

  const navigateToEdit = () => {
    if (selectedUser?.length === 1) {
      navigate(`/offer/${selectedUser[0].broj}`);
    } else {
      openNotificationWithIcon("warning", "Select one offer to edit");
    }
  };

  const handleDeleteUser = () => {
    if (selectedUser) {
      const offerIds = selectedUser.map((offer) => offer.key);
      actions.deleteOffer(offerIds);
      setSelectedUser(null);
    }
  };

  const filterByDobavljac = (filterValue) => {
    if (!filterValue) {
      return;
    }
    setSearchDobavljac(filterValue);
    actions.getOffers(filterValue, searchYear);
  };

  const filterByYear = (filterValue) => {
    if (!filterValue) {
      return;
    }

    setSearchYear(filterValue);
    actions.getOffers(searchDobavljac, filterValue);
  };

  return (
    <div className="px-8 py-4">
      {contextHolder}
      <Flex justify="space-between" className="mb-4">
        <ActionButtons
          navigateToAdd={navigateToWebCalculator}
          navigateToEdit={navigateToEdit}
          handleDelete={handleDeleteUser}
          selectedUser={selectedUser}
        />

        <Flex>
          <Select
            defaultValue="Godina"
            bordered={false}
            options={yearsSelectOptions}
            onChange={(e) => filterByYear(e)}
            className="max-w-[210px]"
          />

          {loggedUser?.role === RoleOptionsValues.LEASING_KORISNIK && (
            <Select
              defaultValue="Dobavljač"
              bordered={false}
              options={supplierSelectOptions}
              onChange={(e) => filterByDobavljac(e)}
              className="max-w-[210px]"
            />
          )}

          {loggedUser?.role === RoleOptionsValues.DOBAVLJAC_ADMIN && (
            <Select
              defaultValue="Korisnik"
              bordered={false}
              className="max-w-[210px]"
            />
          )}

          <Search
            className="bg-light-blue rounded-l-md rounded-r-sm w-80"
            placeholder="Traži po nazivu klijenta"
            onSearch={(value) => setSearchClient(value)}
            enterButton
          />
        </Flex>
      </Flex>
      <Table
        className={styles.table}
        columns={columns}
        dataSource={tableData}
        rowSelection={{
          ...rowSelection,
        }}
        // onChange={onChange}
      />
      {detailsModal && (
        <OfferDetailsModal
          detailsModal={detailsModal}
          setDetailsModal={setDetailsModal}
          currentOffer={currentOffer}
        />
      )}
      {posaljiPonudu && (
        <SendEmailModal
          posaljiPonudu={posaljiPonudu}
          setPosaljiPonudu={setPosaljiPonudu}
          offer={currentOffer}
          actions={actions}
        />
      )}
    </div>
  );
};

export default PonudeRestRoles;
